import { fromJS } from 'immutable'
import { checkStatus, json, CustomerAPI, ConversationAPI, RxCustomerAPI } from '@driftt/dapper'
import { Org } from './models'

export const api = {
  create(settings) {
    return CustomerAPI.post('/organizations', settings, { auth: false, clientId: true })
      .then(checkStatus)
      .then(json)
      .then(Org)
  },
  fetch(id) {
    return CustomerAPI.get(`/organizations/${id}`)
      .then(checkStatus)
      .then(json)
      .then(Org)
  },
  fetchProperties(id) {
    return CustomerAPI.get(`/organizations/${id}/all_properties`)
      .then(checkStatus)
      .then(json)
  },
  patchProperties(id, updates) {
    return RxCustomerAPI.patch(`/organizations/${id}/properties2`, updates)
      .checkStatus()
      .map(res => res.response)
  },
  update(id, updates) {
    return CustomerAPI.patch(`/organizations/${id}`, updates)
      .then(checkStatus)
      .then(json)
      .then(Org)
  },
  checkHandle(handle) {
    return CustomerAPI.head(`/organizations/handle_check`, { handle })
  },
  batchUpdateUserScopes(id, updates) {
    return CustomerAPI.patch(`/organizations/${id}/users/scopes`, updates)
      .then(checkStatus)
      .then(json)
  },
  sendExistingInvitationsViaEmail(orgId, invitations) {
    return CustomerAPI.post(`/organizations/${orgId}/users/plugin-invite`, invitations)
  },
  sendInvitationsViaEmail(orgId, invitations) {
    return CustomerAPI.post(`/organizations/${orgId}/users/invitations2`, invitations).then(json)
  },
  sendInvitationsViaSlack(orgId, invitations) {
    return CustomerAPI.post(`/organizations/${orgId}/users/invitations2/slack`, invitations).then(json)
  },
  getLeaderboardUrl() {
    return CustomerAPI.get(`/leaderboard/url`).then(json)
  },
  toggleChillbot(chillbotStatus) {
    return ConversationAPI.put(`/chill`, { enabled: chillbotStatus })
  },
  fetchEndUserCount(orgId) {
    return RxCustomerAPI.post(`/organizations/${orgId}/end_users/search?from=0&size=1`, {})
      .checkStatus()
      .map(res => res.response)
  },
  createEndUser(orgId, endUser) {
    return CustomerAPI.post(`/organizations/${orgId}/end_users`, endUser)
      .then(checkStatus)
      .then(json)
  },
  getDriftHelpStatus(orgId) {
    return CustomerAPI.get(`/organizations/${orgId}/bots/support`)
      .then(json)
  },
  getHasLimitedContactsMktEmail(orgId) {
    return RxCustomerAPI.get(`/cutover/organizations/${orgId}?namespace=HAS_LIMITED_CONTACTS_MKTING_EMAIL`)
      .checkStatus()
      .map(res => res.response)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/org/api.js